/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ヘッダの項目（マンガ/ランキング/単行本/記事など）
 * @export
 * @interface HeaderModel
 */
export interface HeaderModel {
    /**
     * ヘッダーの名
     * @type {string}
     * @memberof HeaderModel
     */
    name: string;
    /**
     * ヘッダーのアイコン画像パース
     * @type {string}
     * @memberof HeaderModel
     */
    imagePath?: string;
    /**
     * ヘッダーをクリックすると、遷移されるURL
     * @type {string}
     * @memberof HeaderModel
     */
    path: string;
    /**
     * ヘッダーの表示の優先度
     * @type {number}
     * @memberof HeaderModel
     */
    displayOrder: number;
    /**
     * ヘッダーをクリックすると別タブで開くかどうかのフラグ
     * @type {boolean}
     * @memberof HeaderModel
     */
    isNewTab?: boolean;
    /**
     * ヘッダーが公開されるかどうかのフラグ
     * @type {boolean}
     * @memberof HeaderModel
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the HeaderModel interface.
 */
export function instanceOfHeaderModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "path" in value;
    isInstance = isInstance && "displayOrder" in value;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function HeaderModelFromJSON(json: any): HeaderModel {
    return HeaderModelFromJSONTyped(json, false);
}

export function HeaderModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeaderModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'imagePath': !exists(json, 'imagePath') ? undefined : json['imagePath'],
        'path': json['path'],
        'displayOrder': json['displayOrder'],
        'isNewTab': !exists(json, 'isNewTab') ? undefined : json['isNewTab'],
        'enabled': json['enabled'],
    };
}

export function HeaderModelToJSON(value?: HeaderModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'imagePath': value.imagePath,
        'path': value.path,
        'displayOrder': value.displayOrder,
        'isNewTab': value.isNewTab,
        'enabled': value.enabled,
    };
}

